import {useQuery} from "@tanstack/react-query"
import {UNLIMITED_PAGE_SIZE} from "data/constants"
import {orderBy, uniq} from "lodash"
import {useMemo} from "react"
import {outcomeService} from "services"
import {Settings} from "types/settings"

const INITIAL_DATA: Settings.OutcomeGroup[] = []

export const useAllOutcomeGroups = () => {
    const query = useQuery(
        ["all-outcome-groups"],
        async () => {
            const {data} = await outcomeService.getAll({
                range: {page: 1, pageSize: UNLIMITED_PAGE_SIZE},
                linkedEntities: true
            })
            return data.map((item) => ({...item, id: item.outcomeGroupId})) as Settings.OutcomeGroup[]
        },
        {
            refetchOnMount: false,
            staleTime: 30 * 60 * 1000 // 30 minutes
        }
    )

    return {outcomeGroups: query.data ?? INITIAL_DATA, isLoading: query.isFetching}
}

export const useGroupedOutcomes = () => {
    const {outcomeGroups} = useAllOutcomeGroups()

    return useMemo(
        () =>
            outcomeGroups
                .map((outcomeGroup) => {
                    return {
                        label: outcomeGroup.name,
                        options: orderBy(outcomeGroup.outcomes, ["name"], ["asc"])
                    }
                })
                .filter((group) => group.options.length > 0),
        [outcomeGroups]
    )
}
